<template>
	<div>
		<v-card :dark="true" :color="color" :height="height">
			<v-layout>
				<div>
					<v-card-title style="color: white">{{ resourceName }}</v-card-title>
					<v-card-subtitle style="color: white">{{
						environmentName
					}}</v-card-subtitle>
				</div>

				<v-spacer />

				<action-menu
					class="ma-4"
					v-if="!noAction"
					entity="resource"
					:title="$tc('entities.resource.title', 1)"
					:data="resourceStatus"
					fab
					persistent
				/>
			</v-layout>

			<v-card-text style="color: white">
				<div v-if="jobId" class="title">
				<div style="display: flex; width: 100%; flex-wrap: wrap; justify-content: center;">
						

						<v-spacer />

						<v-btn
							v-if="!noAction"
							fab
							@click="regProductions"
							class="mr-2 mt-2"
							color="info"
							small
						>
							<v-icon>mdi-information-variant</v-icon>
						</v-btn>

						<v-btn
							v-if="!noAction"
							fab
							@click="regSearchClick"
							class="mr-2 mt-2"
							color="info"
							small
						>
							<v-icon>mdi-history</v-icon>
						</v-btn>

						<v-btn
							v-if="!noAction"
							fab
							@click="resourceJobsDialogOpen = true"
							color="primary"
						>
							<v-icon>mdi-format-list-numbers</v-icon>
						</v-btn>
					</div>
				</div>
				<div class="title">{{ regTypeDescription }}</div>
				<div v-if="jobId" class="title">
					<v-layout>
						<div>
							<span :title="value">JOB {{ truncText(value) }}</span> <br />
							<span>{{ jobDescription }}</span>
						</div>
						<v-btn
							icon
							dark
							class="mt-3"
							@click="
								$emit('input', '');
								$emit('clearJob');
							"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>
						
						<reg-resource-menu
							v-if="!noAction"
							@click="$emit('change-resource', $event)"
							:resourceId="resourceId"
							:loading="resourceMenuLoading"
						></reg-resource-menu>
					</v-layout>
				</div>

				<form v-if="!noAction" v-on:submit.prevent="$emit('confirmJob', value)">
					<v-layout v-if="!jobId">
						<v-text-field
							label="Job"
							v-model="job"
							@input="$emit('input', $event)"
						></v-text-field>
						<v-btn
							icon
							dark
							class="mt-3"
							@click="
								$emit('input', '');
								$emit('clearJob');
							"
						>
							<v-icon>mdi-close</v-icon>
						</v-btn>

						<v-btn
							class="mr-2 mt-2"
							fab
							@click="regProductions"
							color="info"
							small
						>
							<v-icon>mdi-information-variant</v-icon>
						</v-btn>

						<v-btn
							v-if="!noAction"
							class="mr-2 mt-2"
							fab
							@click="regSearchClick"
							color="info"
							small
						>
							<v-icon>mdi-history</v-icon>
						</v-btn>
						<v-btn
							v-if="!noAction"
							fab
							color="primary"
							@click="resourceJobsDialogOpen = true"
						>
							<v-icon>mdi-format-list-numbers</v-icon>
						</v-btn>
					</v-layout>
				</form>
			</v-card-text>
		</v-card>

		<resource-jobs-dialog
			v-model="resourceJobsDialogOpen"
			:resourceId="resourceId"
			:jobCode="value"
			@click="resourceJobsDialogClick"
		></resource-jobs-dialog>
		<dialog-d ref="dialogSearchRef" :title="$tc('entities.reg.title', 2)">
			<reg-search
				ref="regSearchRef"
				noSearch
				:jobId="jobId"
				:resourceId="resourceId"
				:dtStart="jobId ? null : dateSearchMax.start"
			/>
		</dialog-d>

		<!-- Informações sobre a quantidade produzida/quantidade real e a total-->
		<dialog-d
			ref="dialogProductionRef"
			:title="$tc('entities.reg.production', 2)"
		>
			<v-card-title style="color: black">
				Produção Estimada:
				{{
					qtComp.qtEstimated ? qtComp.qtEstimated.toLocaleString() : 0
				}}</v-card-title
			>
			<v-card-title style="color: black">
				Produção {{ resourceName }} :
				{{ qtComp.qtReal ? qtComp.qtReal.toLocaleString() : 0 }}</v-card-title
			>

			<v-card-title style="color: black">
				Outras atividades:
				{{
					qtComp.qtTotalProd ? qtComp.qtTotalProd.toLocaleString() : 0
				}}</v-card-title
			>

			<v-card-title style="color: black">
				Total:
				{{ qtComp.total ? qtComp.total.toLocaleString() : 0 }}</v-card-title
			>
		</dialog-d>
	</div>
</template>

<script>
	import resourceJobsDialog from "../../components/dialogs/resourceJobsDialog";
	import jobStageService from "@/services/jobStageService.js";
	import regResourceMenu from "@/components/registries/regResourceMenu";
	import regSearch from "@/components/registries/regSearch";
	import moment from "moment";
	export default {
		name: "reg-type-card",
		components: {
			regResourceMenu,
			resourceJobsDialog,
			regSearch,
		},
		props: [
			"value",
			"jobId",
			"jobDescription",
			"color",
			"resourceId",
			"resourceName",
			"resourceWithSameJob",
			"environmentName",
			"regTypeDescription",
			"noAction",
			"height",
			"resourceMenuLoading",
			"resourceStatus",
		],
		watch: {
			value(value) {
				this.job = value;
			},
		},
		data() {
			return {
				job: "",
				qtdProducao: null,
				resourceJobsDialogOpen: false,
				dateSearchMax: {},
			};
		},

		computed: {
			qtComp() {
				let qtTotalProd = 0;
				let qtEstimated = 0;
				let qtReal = 0;
				let prods = this.qtdProducao;
				if (!prods) return { qtEstimated, qtReal };
				prods.forEach((p) => {
					if (p.unitId != null) {
						qtEstimated += p.qtEstimated;
					}
					qtReal += p.qtReal;
				});

				let allProds = this.resourceWithSameJob;
				if (!allProds) return { qtEstimated, qtReal };
				allProds.forEach((p) => {
					p.forEach((x) => {
						qtTotalProd += x.qtReal;
					});
				});

				let total = qtTotalProd + qtReal;

				return { qtEstimated, qtReal, qtTotalProd, total };
			},
		},

		mounted() {
			//console.log("resssssss", this.resourceStatus);
		},
		methods: {
			truncText(texto) {
				const larguraTela = window.innerWidth;
				if(larguraTela < 500){
					let comprimentoMaximo = 15
					if (texto.length > comprimentoMaximo) {
						return texto.substring(0, comprimentoMaximo) + '...';
					}
					return texto;
				}

				if(larguraTela < 700){
					let comprimentoMaximo = 20
					if (texto.length > comprimentoMaximo) {
						return texto.substring(0, comprimentoMaximo) + '...';
					}
					return texto;
				}
				return texto;
			},
			getDateMaxRegSearch() {
				let days = 7;
				let now = moment(new Date());
				let old = moment(new Date());
				old.subtract(days, "days");
				let start = old.toJSON();
				let end = now.toJSON();
				this.dateSearchMax = { start, end };
			},
			async regSearchClick() {
				console.log("aaaaaaaaaaaaaaaaaaaaaaaaaaa");
				this.$forceUpdate();
				let dialogRef = this.$refs.dialogSearchRef;
				dialogRef.open();
				await this.$forceUpdate();
				this.getDateMaxRegSearch();
				await this.$forceUpdate();
				let regSearch = this.$refs.regSearchRef;
				await regSearch.search();
			},

			async regProductions() {
				if (this.value != undefined && this.resourceId != undefined) {
					let res = await jobStageService.getByJobCodeAndResource(
						this.value,
						this.resourceId
					);

					this.qtdProducao = res.data.jobStageItemProds;
					let dialogRefProduction = this.$refs.dialogProductionRef;

					console.log("dialogRefProduction", dialogRefProduction);
					dialogRefProduction.open();
					await this.$forceUpdate();
				}

				this.$forceUpdate();
				await this.$forceUpdate();
			},

			// Executa quando seleciona um job na lista de disponíveis
			resourceJobsDialogClick(job) {
				this.job = job;
				this.$emit("confirmJob", job);
				this.$emit("input", job);
				this.$emit("createStages");
				this.resourceJobsDialogOpen = false;
			},
			LightenDarkenColor(col, amt) {
				var usePound = false;
				if (col[0] == "#") {
					col = col.slice(1);
					usePound = true;
				}

				var num = parseInt(col, 16);

				var r = (num >> 16) + amt;

				if (r > 255) r = 255;
				else if (r < 0) r = 0;

				var b = ((num >> 8) & 0x00ff) + amt;

				if (b > 255) b = 255;
				else if (b < 0) b = 0;

				var g = (num & 0x0000ff) + amt;

				if (g > 255) g = 255;
				else if (g < 0) g = 0;

				return (usePound ? "#" : "") + (g | (b << 8) | (r << 16)).toString(16);
			},
		},
	};
</script>

<style scoped>

.description_container {
    white-space: nowrap;
    width: 99%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
}


@media (max-width: 750px)
{
  .facet_card
   {
    display: block;
    font-size: smaller;
   }

}
</style>
